import type { IRouteContext } from '@shared/types/route-context'
import { EAccountEditingType } from '@shared/types/constants/account-editing-type'
import { ERouterList } from '@internal/router/constants/router-list'

export const settingsEditType = ({ to, next }: IRouteContext) => {
  const possibleAccountEditingTypeList = [
    EAccountEditingType.EMAIL,
    EAccountEditingType.NAME,
    EAccountEditingType.PASSWORD,
    EAccountEditingType.PHONE,
  ]
  const type = to.query?.type as EAccountEditingType
  type && possibleAccountEditingTypeList.includes(type) ? next() : next({ name: ERouterList.SETTINGS })
}
